import { AdminLayout } from "@/views/layouts/AppLayout";
import { SystemBackendAccountPage } from "@/views/pages/systemBackendAccount/list";
import { BackendAccountFormPage } from "@/views/pages/systemBackendAccount/list/BackendAccountFormPage";
import { SystemRolePage } from "@/views/pages/systemBackendAccount/role";
import { RoleFormPage } from "@/views/pages/systemBackendAccount/role/RoleFormPage";
import { RoleDetailPage } from "@/views/pages/systemBackendAccount/role/RoleDetailPage";
import { OrganizationalStructurePage } from "@/views/pages/systemBackendAccount/organizationalStructure/OrganizationalStructurePage";
import { OrganizationPersonFormPage } from "@/views/pages/systemBackendAccount/organizationalStructure/OrganizationPersonFormPage";
import type { AdminRouteObject } from "../index";

/** 系统管理路由，保留旧 Vue 版本的 URL 层级，便于菜单和接口迁移并行。 */
export const systemManagentRoutes: AdminRouteObject = {
    path: "/systemMangement",
    element: <AdminLayout />,
    handle: { title: "系统管理" },
    children: [
        {
            path: "systemManage",
            handle: { title: "组织用户" },
            children: [
                {
                    path: "organizationalStructure",
                    element: <OrganizationalStructurePage />,
                    // 列表页沿用 Vue 的三类权限，确保部门和员工操作不会因路由过滤提前丢失。
                    handle: {
                        title: "组织架构",
                        permissions: ["ROLE_ORG_R", "ROLE_DEPT_W", "ROLE_EMPLOYEE_W"]
                    }
                },
                {
                    path: "organizationalStructure/add",
                    element: <OrganizationPersonFormPage />,
                    handle: { title: "新增员工", permissions: ["ROLE_EMPLOYEE_W"] }
                },
                {
                    path: "organizationalStructure/edit",
                    element: <OrganizationPersonFormPage />,
                    handle: { title: "编辑员工", permissions: ["ROLE_EMPLOYEE_W"] }
                },
                {
                    path: "backendAccount",
                    element: <SystemBackendAccountPage />,
                    handle: {
                        title: "后台用户",
                        // 列表页需要同时保留查看与管理权限，页面按钮再做细粒度控制。
                        permissions: ["ROLE_USER_R", "ROLE_USER_W"]
                    }
                },
                {
                    path: "role",
                    element: <SystemRolePage />,
                    handle: {
                        title: "角色管理",
                        // 角色列表保留 Vue 的查看、管理权限集合，避免管理用户无法进入列表页。
                        permissions: ["ROLE_ROLE_R", "ROLE_ROLE_W"]
                    }
                },
                {
                    path: "backendAccount/add",
                    element: <BackendAccountFormPage />,
                    handle: { title: "新增后台用户", permissions: ["ROLE_USER_W"] }
                },
                {
                    path: "backendAccount/edit",
                    element: <BackendAccountFormPage />,
                    handle: { title: "编辑后台用户", permissions: ["ROLE_USER_W"] }
                },
                {
                    path: "backendAccount/edit/:id",
                    element: <BackendAccountFormPage />,
                    handle: { title: "编辑后台用户", permissions: ["ROLE_USER_W"] }
                },
                {
                    path: "role/add",
                    element: <RoleFormPage />,
                    handle: { title: "新增角色", permissions: ["ROLE_ROLE_W"] }
                },
                {
                    path: "role/detail",
                    element: <RoleDetailPage />,
                    handle: { title: "角色详情", permissions: ["ROLE_ROLE_R"] }
                },
                {
                    path: "role/detail/:id",
                    element: <RoleDetailPage />,
                    handle: { title: "角色详情", permissions: ["ROLE_ROLE_R"] }
                },
                {
                    path: "role/edit",
                    element: <RoleFormPage />,
                    handle: { title: "编辑角色", permissions: ["ROLE_ROLE_W"] }
                },
                {
                    path: "role/edit/:id",
                    element: <RoleFormPage />,
                    handle: { title: "编辑角色", permissions: ["ROLE_ROLE_W"] }
                }
            ]
        }
    ]
};

export default systemManagentRoutes;
